var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapVvs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.859 15a5.09 5.09 0 01-3.525-1.387L1.457 9.93a4.578 4.578 0 010-6.7l1.936-1.84A5.092 5.092 0 016.922 0h3.874a5.09 5.09 0 013.525 1.387l1.937 1.841a4.579 4.579 0 010 6.7l-3.874 3.684A5.09 5.09 0 018.859 15zM6.922 1.488c-.914 0-1.773.337-2.417.953l-1.94 1.84a3.144 3.144 0 000 4.597l3.874 3.681a3.496 3.496 0 002.417.954c.914 0 1.772-.338 2.417-.954l3.873-3.68a3.144 3.144 0 000-4.598l-1.937-1.84a3.496 3.496 0 00-2.417-.953h-3.87z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.859 12.788c-.783 0-1.523-.29-2.075-.82L3.278 8.642a2.698 2.698 0 010-3.947l1.753-1.663a2.992 2.992 0 012.075-.815h3.502c.783 0 1.523.29 2.075.819L14.436 4.7a2.698 2.698 0 010 3.947l-3.502 3.322a2.988 2.988 0 01-2.075.819zM7.106 3.703c-.365 0-.71.135-.967.382L4.386 5.75a1.26 1.26 0 000 1.84L7.89 10.92c.516.49 1.42.49 1.936 0l3.503-3.328a1.26 1.26 0 000-1.84l-1.753-1.666a1.392 1.392 0 00-.967-.382H7.106z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.859 10.606L4.84 6.787l2.523-2.393h2.992l2.522 2.393-4.018 3.82z",
    fill: "currentColor"
  })));
}

export default SvgSwapVvs;